module.exports = __webpack_public_path__ + "static/media/Comercio.5c20b605.png";